export const filtersOrderMap = {
  contract: {
    teams: 0,
    status: 1,
    tags: 2,
    class_of_business: 3,
    created_by: 4,
    sourceResourceDisplayName: 5,
    branding: 6,
    endorsementsCount: 7,
    renewals: 8,
  },
};
